import { Button, Col, Row } from "reactstrap";

const RelateFieldsHeader = ({
  autoRelate,
  ignoreAll,
  selectedFields,
  fileHeaders,
}) => {
  return (
    <Row className="align-items-center mb-3">
      <Col xs="12" sm="">
        <h3 className="mb-0">Relate Fields to Data</h3>
      </Col>
      <Col xs="12" sm="auto" className="mt-2 mt-sm-0">
        <Button
          size="sm"
          color="secondary"
          outline
          onClick={ignoreAll}
          disabled={selectedFields.length < 1}
        >
          Clear
        </Button>
        <Button
          size="sm"
          color="primary"
          outline
          onClick={autoRelate}
          disabled={fileHeaders.length < 1}
        >
          Auto Map
        </Button>
      </Col>
    </Row>
  );
};

export default RelateFieldsHeader;
